import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { columnDefinitionsAdapter } from './columnDefinitionsAdapter'
import { ColumnDefinition } from './models/ColumnDefinition'

export const initialColDefState = columnDefinitionsAdapter.getInitialState()

export const columnDefinitionsSlice = createSlice({
  name: 'columnDefinitions',
  initialState: initialColDefState,
  reducers: {
    addMultipleColumnDefinitions: (state, action: PayloadAction<ColumnDefinition[]>) => {
      columnDefinitionsAdapter.upsertMany(state, action.payload)
    },
    removeAllColumnDefinitions: (state) => {
      columnDefinitionsAdapter.removeAll(state)
    },
  },
})

export const { addMultipleColumnDefinitions, removeAllColumnDefinitions } = columnDefinitionsSlice.actions